import { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function ActivityDropdown({ activities, selectedActivity, setSelectedActivity }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (act) => {
    setSelectedActivity(act.id);
    setOpen(false);
  };

  return (
    <div className="relative w-full mb-4" ref={ref}>
      {/* Trigger */}
      <button
        type="button"
        className="w-full border rounded p-2 text-left bg-white flex justify-between items-center"
        onClick={() => setOpen(!open)}
      >
        <span className="truncate">
          {selectedActivity
            ? activities.find((a) => a.id === selectedActivity)?.name
            : "Select activity"}
        </span>
        {open ? <FaChevronUp className="ml-2 text-gray-500" /> : <FaChevronDown className="ml-2 text-gray-500" />}
      </button>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto border rounded bg-white shadow-lg">
          {activities.length === 0 ? (
            <p className="p-2 text-gray-500">No activities available</p>
          ) : (
            activities.map((act) => {
              const start = act.startDate?.toDate ? act.startDate.toDate() : new Date(act.startDate);
              const end = act.endDate?.toDate ? act.endDate.toDate() : new Date(act.endDate);
              const dateLabel =
                start.getTime() === end.getTime()
                  ? start.toLocaleDateString()
                  : `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;

              return (
                <div
                  key={act.id}
                  onClick={() => handleSelect(act)}
                  className={`p-2 cursor-pointer whitespace-normal break-words hover:bg-blue-100 ${
                    selectedActivity === act.id ? "bg-blue-50 font-semibold" : ""
                  }`}
                >
                  <span className="block">{act.name}</span>
                  <span className="block text-sm text-gray-600">{dateLabel}</span>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}
